module.exports = __webpack_public_path__ + "img/t64.c32a5e69.png";